module.exports = __webpack_public_path__ + "media/images/ac_templates/201/smk-0dd2112be6a4eb73357b9f72c5d3a2a5.jpg";